import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const isActive = (v) =>
  v !== undefined &&
  v !== null &&
  v !== "" &&
  !(Array.isArray(v) && v.length === 0);

// Resolve active filters from a FilterPanel config + the current filters object.
// Returns [{ id, label, display, clearKeys }]. dateRange counts as one chip.
const activeEntries = (config = [], filters = {}) => {
  const out = [];
  for (const field of config) {
    if (field.type === "dateRange") {
      const s = filters[field.startKey];
      const e = filters[field.endKey];
      if (isActive(s) || isActive(e)) {
        out.push({
          id: field.startKey,
          label: field.label,
          display: `${s || "…"} → ${e || "…"}`,
          clearKeys: [field.startKey, field.endKey],
        });
      }
      continue;
    }
    const v = filters[field.key];
    if (!isActive(v)) continue;
    let display;
    if (v && typeof v === "object") display = v.label;
    else if (field.options) display = field.options.find((o) => o.value === v)?.label || v;
    else display = v;
    out.push({ id: field.key, label: field.label, display, clearKeys: [field.key] });
  }
  return out;
};

// Count of active filters — for the "N filters active" badge on the Filters button.
export const countActive = (config, filters) => activeEntries(config, filters).length;

export default function FilterChips({ config, filters, onClearKeys, onClearAll }) {
  const entries = activeEntries(config, filters);
  if (entries.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 mb-3">
      {entries.map((e) => (
        <span
          key={e.id}
          className="inline-flex items-center gap-1.5 text-xs bg-indigo-50 text-indigo-700 border border-indigo-100 rounded-full px-2.5 py-1"
        >
          <span className="font-medium">{e.label}:</span> {String(e.display)}
          <button
            onClick={() => onClearKeys(e.clearKeys)}
            className="text-indigo-400 hover:text-indigo-700"
            title="Remove"
          >
            <FontAwesomeIcon icon={faXmark} className="text-[10px]" />
          </button>
        </span>
      ))}
      <button
        onClick={onClearAll}
        className="text-xs text-gray-500 hover:text-red-500 underline ml-1"
      >
        Clear all
      </button>
    </div>
  );
}
